<template>
  <section class="hidden lg:table relative w-full py-40 bg-center bg-no-repeat bg-cover">
    <div class="absolute inset-0 bg-gradient-employer"></div>
  </section>
  <div class="relative">
    <div class="shape absolute start-0 end-0 sm:-bottom-px -bottom-[2px] overflow-hidden z-1 text-white dark:text-slate-900">
      <svg class="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
      </svg>
    </div>
  </div>

  <CompanyMeta
    :logoUrl="company?.logoUrl"
    :bannerUrl="company?.bannerUrl"
  />

  <CompanyInfo
    :company="company"
    :companyJobs="companyJobs"
  />

  <RelatedCompanies
    v-if="relatedCompanies"
    :companies="relatedCompanies"
  />

  <div class="pb-12 pt-4">
    <div class="container">
      <div class="relative shadow-lg dark:shadow-gray-700 px-6 py-8 sm:px-8 sm:py-10 rounded-xl flex items-center justify-between flex-col md:flex-row gap-8 md:gap-4">
        <div class="flex flex-col gap-4 w-full max-w-[500px]">
          <h5 class="text-xl font-semibold">Jetzt Job-Angebote erhalten</h5>
          <p class="text-slate-400">Registriere Dich jetzt in der Fuchsjobs Talentbase und sichere Job-Angebote von Top-Unternehmen aus der IT Branche</p>
        </div>

        <div class="flex items-center justify-center gap-2 flex-shrink-0 flex-wrap sm:flex-nowrap">
          <router-link
            :to="{ name: 'userRegister' }"
            class="btn rounded-md text-white w-auto bg-gradient"
          >
            Registrieren
          </router-link>

          <router-link
            :to="{ name: 'LandingPageIndex' }"
            class="btn rounded-md text-white w-auto bg-slate-400 hover:bg-slate-500 transition"
          >
            Mehr erfahren
          </router-link>
        </div>

        <img class="absolute top-0 left-0 -z-1" src="@/assets/images/company/cta1.svg" />
        <img class="absolute bottom-0 right-0 -z-1" src="@/assets/images/company/cta2.svg" />
      </div>
    </div>
  </div>
</template>

<script>
import CompanyService from '@/services/company.service'
import CompanyInfo from '@/pages/company/CompanyInfo.vue'
import CompanyMeta from '@/pages/company/CompanyMeta.vue'
import RelatedCompanies from '@/pages/company/RelatedCompanies.vue'

export default {
  components:{
    CompanyInfo, CompanyMeta, RelatedCompanies,
  },
  data() {
    return {
      company : {},
      companyJobs: null,
      relatedCompanies: null,
    }
  },
  mounted () {
    this.slug = this.$route.params.slug;
    this.fetchCompanyData(this.slug);
  },
  methods: {
    async fetchCompanyData(slug) {
      try {
        const response = await CompanyService.getCompanyBySlug(slug);
        this.company = response.data;
        console.log('company', this.company)

        const responseJobs = await CompanyService.getCompanyJobs(slug);
        this.companyJobs = responseJobs.data.jobs;

        const responseRelatedCompanies = await CompanyService.getRelatedCompanies(slug);
        this.relatedCompanies = responseRelatedCompanies.data;
      } catch (error) {
        console.error("Error fetching company jobs:", error);
      }
    },
  }
}
</script>